<h3 class="title">Recipient Details {{typeOfPayment}}</h3>
@if (payment?.destinationUnitBankAccountId) {
    <terra-unit-payment-overview-key-value-pair  key="Name" [value]="unitContactName" iconName="person" />
}
<terra-unit-payment-overview-key-value-pair key="{{recipientTitle}}" [value]="recipientName$ | async" [iconName]="iconName" [link]="linkToBankAccountPage" />
<terra-unit-payment-overview-key-value-pair key="Account Number" [value]="(payment?.recipient?.bankAccount?.accountNumber | accountNumberToAstrix : 4)" iconName="attach_money" />
<terra-unit-payment-overview-key-value-pair key="US ABA Routing Number" [value]="payment?.recipient?.bankAccount?.usAbaRoutingNumber" iconName="pin" />
